import * as environment from './environmentURL';
class URLData {
    constructor(params) {
        this.getLocalizedPath = (path = '') => {
            if (path !== '') {
                if (this.lang !== 'et' && !this.pathContainsLocale(path)) {
                    return this.localizedPath.concat(path);
                }
                return path;
            }
            return this.localizedPath;
        };
        this.getSelfServiceLink = (path = '') => {
            if (!['selfservice', 'frontline'].includes(this.app)) {
                if (path !== '') {
                    if (this.pathContainsLocale(path)) {
                        return this.selfServiceBaseURL.concat(path);
                    }
                    return this.selfServiceURL.concat(path);
                }
                return this.selfServiceURL;
            }
            return this.pathContainsLocale(path) ? path : this.getLocalizedPath(path);
        };
        this.getTranslationsURL = (lang = this.lang) => {
            return `${this.commonAPIBaseURL}/translations/${lang}?appNames=iocc`;
        };
        this.getTranslationsStatisticsUrl = () => {
            return `${this.commonAPIBaseURL}/translations/statistics`;
        };
        this.pathContainsLocale = (path) => {
            if (!path) {
                return false;
            }
            return path.startsWith('/ru/') || path === '/ru' || path.startsWith('/et/') || path === '/et' || path.startsWith('/en/') || path === '/en';
        };
        this.app = params.app;
        this.tier = params.tier;
        this.lang = params.lang;
        this._publicAPIBaseURL = params.apiBaseURL;
    }
    get selfServiceBaseURL() {
        return environment.getSelfServiceURL(this.tier);
    }
    get publicBaseURL() {
        return environment.getPublicURL(this.tier);
    }
    get teliaShopURL() {
        return environment.getTeliaShopUrl(this.tier);
    }
    get localizedPath() {
        return this.lang !== 'et' && this.app !== 'shop' ? `/${this.lang}` : '';
    }
    get selfServiceURL() {
        return this.selfServiceBaseURL.concat(this.localizedPath);
    }
    get commonAPIBaseURL() {
        return environment.getCommonAPIBaseURL(this.tier);
    }
    getAddressEventsURL(addressId, buildingId, roomId) {
        if (this.app === 'frontline') {
            return `/ciconsultant-api/address-events?addressId=${addressId}&buildingId=${buildingId}&roomId=${!roomId ? '' : roomId}`;
        }
        return `${this.selfServiceBaseURL}/ciconsultant-api/address-events?addressId=${addressId}&buildingId=${buildingId}&roomId=${!roomId ? '' : roomId}`;
    }
    getAddressSearchPopUpURL(tier, addressId, roomId) {
        return `${environment.getPublicURL(tier)}/ressapi/location-search-ui/?:id,id_type,T1,T2,T4,T5,T6,qlevel,email,room_id:${!!addressId ? addressId : ''},A,,,,,,,,${!!roomId ? roomId : ''}`;
    }
    getNewAddressEventUrl(addressId, buildingId, addressText, roomId, roomText) {
        const encodedAddressText = encodeURIComponent(addressText);
        const encodedRoomText = roomText ? encodeURIComponent(roomText) : null;
        const path = `/teenindus/aadressi-syndmuse-lisamine/${addressId}/${buildingId}${!roomId ? '' : `/${roomId}`}?addressText=${encodedAddressText}${encodedRoomText ? `&roomText=${encodedRoomText}` : ''}`;
        return `${this.selfServiceBaseURL}${path}`;
    }
    getTvComparisonDataUrl(language = 'et') {
        return `${this.commonAPIBaseURL}/tv-comparison/v4/packages?language=${language}`;
    }
    getTvB2BComparisonDataUrl(language = 'et') {
        return `${this.commonAPIBaseURL}/tv-comparison/v4/packages/business?language=${language}`;
    }
    getTvChannelComparisonDataUrl(language = 'et') {
        return `${this.commonAPIBaseURL}/tv-comparison/channel-inclusion?language=${language}`;
    }
}
export default URLData;
